import React, { useEffect } from 'react';
import type { SolutionPageConfig } from '../../types/premium';
import MetricsStrip from './MetricsStrip';
import SolutionStoryLead from './SolutionStoryLead';
import SolutionStoryChapters from './SolutionStoryChapters';
import BentoFeatureGrid from './BentoFeatureGrid';
import SolutionJourney from './SolutionJourney';
import PremiumCta from './PremiumCta';
import './SolutionPageLayout.css';

interface SolutionPageLayoutProps {
  hero: React.ReactNode;
  config: SolutionPageConfig;
}

const SolutionPageLayout: React.FC<SolutionPageLayoutProps> = ({ hero, config }) => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="solution-page-premium">
      <section className="solution-page-premium__hero">{hero}</section>
      <MetricsStrip metrics={config.metrics} />
      <SolutionStoryLead lead={config.storyLead} />
      <SolutionStoryChapters chapters={config.storyChapters} />
      <BentoFeatureGrid
        audience={config.bentoAudience}
        eyebrow={config.bentoEyebrow}
        title={config.bentoTitle}
        subtitle={config.bentoSubtitle}
        features={config.features}
      />
      <SolutionJourney title={config.journeyTitle} steps={config.steps} />
      <PremiumCta
        title={config.cta.title}
        paragraphs={config.cta.paragraphs}
        tagline={config.cta.tagline}
        primaryHref={config.cta.primaryHref}
        primaryLabel={config.cta.primaryLabel}
        secondaryHref={config.cta.secondaryHref}
        secondaryLabel={config.cta.secondaryLabel}
      />
    </div>
  );
};

export default SolutionPageLayout;
